import { TSocialMedia } from 'src/models/general';

export const getSocmedDomain = (socmed: TSocialMedia): string => {
  switch (socmed) {
    case 'facebook':
      return 'https://www.facebook.com/';
    case 'instagram':
      return 'https://www.instagram.com/';
    case 'tiktok':
      return 'https://www.tiktok.com/@';
    case 'twitter':
      return 'https://x.com/';
    case 'threads':
      return 'https://www.threads.com/@';
    default:
      return '';
  }
};
